import * as React from 'react';
import * as _ from 'lodash';
import * as InfiniteScroll from 'react-infinite-scroller';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { match } from 'react-router';
import { History } from 'history';
import { Row, Col, Button } from 'reactstrap';
import { IAuthState } from '../../Auth/store/types';
import AlertCard from './components/AlertCard';
import { AlertsService, IResponseAlerts } from '../../../share/services/alerts';
import MapClusters, { MapClustersTypes, IMapClusters } from 'src/share/components/Maps/MapClusters/MapClusters';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { IReduxState } from 'src/reduxTypes';
import { AlertCardLoader } from 'src/share/components/ChartLoader/AlertCardLoader';
import { FetchType } from 'src/modules/Case/View/caseView.type';
import AgencyFilter from 'src/share/components/AgencyFilter/AgencyFilter';
import './alertView.css';
import { RoutesModules } from 'src/modules/Routing/types';

export interface IAlertViewState {
  alerts: IResponseAlerts
  page: number,
  pages: number,
  size: number,
  loading: boolean;
  filterByAgency?: string;
  fetchingData: boolean;
};

export interface IAlertViewProps {
  auth: IAuthState;
  history: History;
  match: match<{ caseId?: string, closed?: string }>;
  permissionCase?: boolean;
};
const InitialState: IAlertViewState = {
  alerts: { total: 0, results: [] },
  loading: true,
  page: 0,
  pages: 0,
  size: 10,
  fetchingData: false
}
export class AlertView extends React.Component<IAlertViewProps, IAlertViewState> {
  public scrollParentRef;
  constructor(props: IAlertViewProps) {
    super(props);
    this.state = _.cloneDeep(InitialState);
  }
  public componentDidMount() {
    this.loadData()
  }
  public componentDidUpdate(prevProps) {
    const prevClosed = prevProps.match.params.closed;
    const closed = this.props.match.params.closed;
    if (prevClosed !== closed) {
      this.setState(_.cloneDeep(InitialState), () => this.loadData())
    }
  }
  public async loadData(fetch = FetchType.Initial) {
    try {
      const isInitialOrFiltering = fetch === FetchType.Initial || fetch === FetchType.Filter;
      await new Promise(res => {
        this.setState(state => ({
          ...isInitialOrFiltering ? _.cloneDeep(InitialState) : state,
          fetchingData: true
        }), res)
      })
      const data = await this.fetch();
      this.setState((state) => ({
        alerts: {
          results: [...state.alerts.results, ...data.results],
          total: data.total
        },
        loading: false,
        fetchingData: false,
        pages: data.total / 8
      }))
    } catch (error) {
      toastr.error('Error', 'There was a problem connecting to the server')
      this.setState({ loading: false })
    }
  }
  public loadMore = (e) => {
    if (this.state.alerts.results.length < this.state.alerts.total && e >= 1 && !this.state.fetchingData) {
      this.loadData(FetchType.Infinite);
    }
  }
  public async fetch() {
    const { caseId, closed } = this.props.match.params;
    const last = this.state.alerts.results.length;
    return AlertsService.get({
      page: last / 8,
      size: 8,
      sort: [{ createdAt: { order: 'desc' } }],
      stop: closed ? true : false,
      caseId,
      filterByAgency: this.state.filterByAgency
    });
  }
  public redirectToClose = () => {
    this.props.history.push(`/close/${this.props.match.params.caseId}`)
  }
  public redirectToEdit = () => {
    this.props.history.push(`/case/edit/${this.props.match.params.caseId}`)
  }
  public redirectToInfo = () => {
    this.props.history.push(`/case/cross-border/${this.props.match.params.caseId}`)
  }
  public redirectToCreateAlert = () => {
    this.props.history.push(`/alerts/add/${this.props.match.params.caseId}`)
  }
  public filterByAgency = (agencyCode: string) => {
    this.setState({ filterByAgency: agencyCode }, () => this.loadData(FetchType.Filter))
  }
  public getClusters(): IMapClusters[] {
    return this.state.alerts.results.map(alert =>
      ({
        id: alert.alertId,
        lat: alert.center.lat,
        lng: alert.center.lng,
        radius: alert.radius,
        caseId: alert.caseId,
        date: alert.createdAt,
        location: alert.location,
        expirationDate: alert.expirationDate,
        expired: alert.expired,
        stop: alert.stop
      })
    );
  }
  public render() {
    const { caseId, closed } = this.props.match.params;
    const { alerts, fetchingData, loading } = this.state;
    const alertsIssued = alerts && alerts.results.length > 0;
    const clusters = this.getClusters();
    return (
      <div className="alert-view">
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMore}
          hasMore={this.state.page <= this.state.pages}
          useWindow={false}
        >
          <Row>
            <Col className={"col-lg-7 col-md-7 col-sm-7 d-none d-sm-block d-xs-none"}>
              <div className={"mapContainer"}>
                {alertsIssued && <AgencyFilter changeAgency={this.filterByAgency} showOnlyAdmin={true} loading={loading} />}
                <MapClusters
                  clusters={clusters}
                  history={this.props.history}
                  mapType={MapClustersTypes.ALERTS}
                />
              </div>
              {
                caseId &&
                <div className="buttonsMap">
                  {
                    this.props.permissionCase !== false &&
                    <>
                      <Button className="btn" onClick={this.redirectToClose}>
                        Close
                      </Button>
                      <Button className="btn" onClick={this.redirectToEdit}>
                        Edit Case
                      </Button>
                    </>
                  }
                  <Button className="btn-blue btn btn-secondary" onClick={this.redirectToCreateAlert}>
                    Create an Alert
                  </Button>
                </div>
              }
            </Col>
            <Col className="alertsContainer col-lg-5 col-md-5 col-sm-5 col-xs-12 no-padding">
              <div className={`alerts${alertsIssued ? '' : ' empty'}`}>
                {
                  alertsIssued ?
                    alerts.results.map((alert) => <AlertCard key={alert.alertId} alert={alert} {...this.props} />)
                    :
                    !loading ?
                      <h4 className="no-results">{closed ? "No alerts issued" : "No active alerts"}</h4> : null
                }
                {
                  (loading || fetchingData) &&
                  Array.apply(null, { length: 5 }).map((data, index) => <AlertCardLoader key={index} />)
                }
              </div>
            </Col>
          </Row>
        </InfiniteScroll>
      </div >
    );
  }
}

const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});
export default SidebarContainer(RoutesModules.ALERTS)(connect(mapStateToProps)(AlertView));
export const AlertsByCase = connect(mapStateToProps)(AlertView);



// WEBPACK FOOTER //
// ./src/modules/Alert/View/AlertView.tsx